import { isHashMap as isHashMap$1, empty as empty$1, make as make$1, fromIterable as fromIterable$1, isEmpty as isEmpty$1, get as get$1, getHash as getHash$1, unsafeGet as unsafeGet$1, has as has$1, hasHash as hasHash$1, set as set$1, keys as keys$1, values as values$1, size as size$1, beginMutation as beginMutation$1, endMutation as endMutation$1, mutate as mutate$1, modifyAt as modifyAt$1, modifyHash as modifyHash$1, modify as modify$1, union as union$1, remove as remove$1, removeMany as removeMany$1, map as map$1, flatMap as flatMap$1, forEach as forEach$1, reduce as reduce$1, filter as filter$1, compact as compact$1, filterMap as filterMap$1, findFirst as findFirst$1 } from '../../internal/HashMap.esm.js';
import { keySet as keySet$1 } from '../../internal/HashMap/keySet.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category refinements
 */
const isHashMap = isHashMap$1;

/**
 * Creates a new `HashMap`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * Constructs a new `HashMap` from an array of key/value pairs.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Constructs a new `HashMap` from an iterable of key/value pairs.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = fromIterable$1;

/**
 * Checks if the `HashMap` contains any entries.
 *
 * @since 2.0.0
 * @category elements
 */
const isEmpty = isEmpty$1;

/**
 * Safely lookup the value for the specified key in the `HashMap` using the
 * internal hashing function.
 *
 * @since 2.0.0
 * @category elements
 */
const get = get$1;

/**
 * Lookup the value for the specified key in the `HashMap` using a custom hash.
 *
 * @since 2.0.0
 * @category elements
 */
const getHash = getHash$1;

/**
 * Unsafely lookup the value for the specified key in the `HashMap` using the
 * internal hashing function.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeGet = unsafeGet$1;

/**
 * Checks if the specified key has an entry in the `HashMap`.
 *
 * @since 2.0.0
 * @category elements
 */
const has = has$1;

/**
 * Checks if the specified key has an entry in the `HashMap` using a custom
 * hash.
 *
 * @since 2.0.0
 * @category elements
 */
const hasHash = hasHash$1;

/**
 * Sets the specified key to the specified value using the internal hashing
 * function.
 *
 * @since 2.0.0
 */
const set = set$1;

/**
 * Returns an `IterableIterator` of the keys within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const keys = keys$1;

/**
 * Returns a `HashSet` of keys within the `HashMap`.
 *
 * @since 2.0.0
 * @category getter
 */
const keySet = keySet$1;

/**
 * Returns an `IterableIterator` of the values within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const values = values$1;

/**
 * Returns the number of entries within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const size = size$1;

/**
 * Marks the `HashMap` as mutable.
 *
 * @since 2.0.0
 */
const beginMutation = beginMutation$1;

/**
 * Marks the `HashMap` as immutable.
 *
 * @since 2.0.0
 */
const endMutation = endMutation$1;

/**
 * Mutates the `HashMap` within the context of the provided function.
 *
 * @since 2.0.0
 */
const mutate = mutate$1;

/**
 * Set or remove the specified key in the `HashMap` using the specified
 * update function. The value of the specified key will be computed using the
 * provided hash.
 *
 * The update function will be invoked with the current value of the key if it
 * exists, or `None` if no such value exists.
 *
 * @since 2.0.0
 */
const modifyAt = modifyAt$1;

/**
 * Alter the value of the specified key in the `HashMap` using the specified
 * update function. The value of the specified key will be computed using the
 * provided hash.
 *
 * The update function will be invoked with the current value of the key if it
 * exists, or `None` if no such value exists.
 *
 * This function will always either update or insert a value into the `HashMap`.
 *
 * @since 2.0.0
 */
const modifyHash = modifyHash$1;

/**
 * Updates the value of the specified key within the `HashMap` if it exists.
 *
 * @since 2.0.0
 */
const modify = modify$1;

/**
 * Performs a union of this `HashMap` and that `HashMap`.
 *
 * @since 2.0.0
 */
const union = union$1;

/**
 * Remove the entry for the specified key in the `HashMap` using the internal
 * hashing function.
 *
 * @since 2.0.0
 */
const remove = remove$1;

/**
 * Removes all entries in the `HashMap` which have the specified keys.
 *
 * @since 2.0.0
 */
const removeMany = removeMany$1;

/**
 * Maps over the entries of the `HashMap` using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = map$1;

/**
 * Chains over the entries of the `HashMap` using the specified function.
 *
 * **NOTE**: the hash and equal of both maps have to be the same.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatMap = flatMap$1;

/**
 * Applies the specified function to the entries of the `HashMap`.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEach = forEach$1;

/**
 * Reduces the specified state over the entries of the `HashMap`.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce = reduce$1;

/**
 * Filters entries out of a `HashMap` using the specified predicate.
 *
 * @since 2.0.0
 * @category filtering
 */
const filter = filter$1;

/**
 * Filters out `None` values from a `HashMap` of `Options`s.
 *
 * @since 2.0.0
 * @category filtering
 */
const compact = compact$1;

/**
 * Maps over the entries of the `HashMap` using the specified partial function
 * and filters out `None` values.
 *
 * @since 2.0.0
 * @category filtering
 */
const filterMap = filterMap$1;

/**
 * Returns the first element that satisfies the specified
 * predicate, or `None` if no such element exists.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirst = findFirst$1;

export { beginMutation, compact, empty, endMutation, filter, filterMap, findFirst, flatMap, forEach, fromIterable, get, getHash, has, hasHash, isEmpty, isHashMap, keySet, keys, make, map, modify, modifyAt, modifyHash, mutate, reduce, remove, removeMany, set, size, union, unsafeGet, values };
